import { useEffect, useState } from "react";
import moment from "moment";
import { useQuery } from "react-query";
//primereact
import { Card } from "primereact/card";
import { Tooltip } from "primereact/tooltip";
import { Skeleton } from "primereact/skeleton";
import { Timeline } from "primereact/timeline";
//components
import Panel from "../../components/panel/panel";
//services
import { getLogs } from "../../services/Logs/getLogs";
import { Button } from "primereact/button";
import { useForm } from "react-hook-form";
import { formatYearDate } from "../../utils/formatDate";
import { useOptionsSelect } from "../../hooks/useOptionsSelect";
import Select from "../../components/input/Select";
import CalendarInput from "../../components/input/CalendarInput";

import noData from "../../assets/errors/noData.png";
import usePermission from "../../hooks/usePermission";
import { useAppContext } from "../../context/AppContext";
const Logs = () => {
  usePermission("161"); // Visualizar logs de todos os usuários;
  const form = useForm();
  const errors = form.formState.errors;
  const { permissions } = useAppContext();

  const [events, setEvents] = useState([]);
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [initialData, setInitialData] = useState({
    start_date: formatYearDate(new Date()).toString(),
    end_date: formatYearDate(new Date()).toString(),
  });

  const {
    data: logs,
    isLoading,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ["logs"],
    queryFn: () => getLogs(initialData),
    enabled: !!permissions?.includes("161"),
  });

  // const {
  //   client,
  //   isLoadingClients,
  // } = useOptionsSelect();

  const actions = [
    { label: "Criar", value: 1 },
    { label: "Editar", value: 3 },
    { label: "Apagar", value: 4 },
  ];

  useEffect(() => {
    if (logs) {
      const mountedEvents = logs.map((data) => {
        const status = getStatus(data.type_log);
        return {
          id: data.id,
          description: data.desc,
          date: moment(data.created_at).format("DD/MM/YYYY - HH:mm:ss"),
          userId: data.user.id,
          user: data.user.name,
          color: status.color,
          status: status.name,
        };
      });

      mountedEvents.sort(
        (a, b) =>
          moment(b.date, "DD/MM/YYYY - HH:mm:ss").toDate() -
          moment(a.date, "DD/MM/YYYY - HH:mm:ss").toDate()
      );

      //console.log("Mounted Events: ", mountedEvents);
      setEvents(mountedEvents);
    }
  }, [logs]);

  function getStatus(type) {
    let color, name;
    switch (type) {
      case 1:
        color = "#00b9a7";
        name = "Criou";
        break;
      case 3:
        color = "#348fe2";
        name = "Editou";
        break;
      case 4:
        color = "#ff5b57";
        name = "Apagou";
        break;
      default:
        break;
    }

    return { color: color, name: name };
  }

  const customizedMarker = (item) => {
    return (
      <>
        <Tooltip
          target={`#status_${item.id}`}
          content={item.status}
          position="top"
        />
        <span
          id={`status_${item.id}`}
          className="flex align-items-center justify-content-center text-white border-circle z-1 shadow-1"
          style={{
            backgroundColor: item.color,
            width: 15,
            height: 15,
            borderRadius: 10,
          }}
        >
          {/* <i className="fa fa-user"></i> */}
        </span>
      </>
    );
  };

  const customizedContent = (item) => {
    return (
      <Card
        title={`${item.id} | ${item.user} - ${item.status}`}
        subTitle={item.date}
        className="pt-3"
        style={{ backgroundColor: "#dee2e6" }}
      >
        <p>{item.description}</p>
      </Card>
    );
  };

  const onSubmit = (data) => {
    setLoadingFilter(true);
    if (data.period_start && data.period_end) {
      data.period_start = formatYearDate(data.period_start);
      data.period_end = formatYearDate(data.period_end);
    }

    setInitialData(data);

    setTimeout(() => {
      refetch().then(() => setLoadingFilter(false));
    }, 200);
  };

  return (
    <>
      <Panel title="Registro de Atividades">
        <form
          className="row justify-content-end mt-4"
          onSubmit={form.handleSubmit(onSubmit)}
        >
          {/* <div className="col-md-4 mb-3 form-group">
            <Select
              name="user_id"
              control={form.control}
              label={isLoadingClients ? "Carregando..." : "Cliente"}
              disabled={isLoadingClients}
              options={client}
              errors={errors}
            />
          </div> */}
          <div className="col-xl-3 col-md-4 mb-3 form-group">
            <Select
              name="type_log"
              control={form.control}
              label={"Ação"}
              options={actions}
              errors={errors}
            />
          </div>
          <div className="col-xl-3 col-md-4 mb-3 form-group">
            <CalendarInput
              name="start_date"
              control={form.control}
              errors={errors}
              label="Data início"
            />
          </div>
          <div className="col-xl-3 col-md-4 mb-3 form-group">
            <CalendarInput
              name="end_date"
              control={form.control}
              errors={errors}
              label="Data Fim"
            />
          </div>
          <div className="col-md-3 mt-3 form-group">
            <Button
              type="submit"
              icon="fa fa-search"
              aria-label="Search"
              loading={loadingFilter}
              className={`rounded-3 py-2.5 w-100`}
            />
          </div>
        </form>
        {isLoading || isRefetching || loadingFilter ? (
          <>
            <Skeleton width="100%" height="80vh" className="mt-3"></Skeleton>
          </>
        ) : events?.length > 0 ? (
          <>
            {window.innerWidth <= 992 ? (
              <Timeline
                value={events}
                className="customized-timeline p-4"
                marker={customizedMarker}
                content={customizedContent}
              />
            ) : (
              <Timeline
                value={events}
                align="alternate"
                className="customized-timeline p-4"
                marker={customizedMarker}
                content={customizedContent}
              />
            )}
          </>
        ) : (
          <div className="d-flex flex-column justify-content-center align-items-center text-center">
            <img src={noData} alt="error" width="400px" />
            <h4>Não encontramos nenhum log por aqui</h4>
          </div>
        )}
      </Panel>
    </>
  );
};

export default Logs;
